<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Supplier Processing</template>
        </page-header>
        <pro-table
            :resource="resource"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="created_at"
            direction="DESC"
            delete-label="title"
            :permissions="true"
            :actions="actions"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../mixins/DataTableSetup';

    export default {
        name: "Submissions",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'submissions',
                numberOfFilters: 4,
                pageActions: {
                    buttons: [],
                    additional: []
                },
                fields: [
                    {
                        name: 'Supplier',
                        column: 'supplier.name',
                    },
                    {
                        name: 'Account Type',
                        column: 'supplier.accountType.name',
                    },
                    {
                        name: 'Form',
                        column: 'application_form.name'
                    },
                    {
                        name: 'Name',
                        column: 'member.full_name',
                        route: '/submissions/{id}/view',
                        linked: true
                    },
                    {
                        name: 'Amount',
                        column: 'amount',
                        sortCol: 'amount',
                        currency: true
                    },
                    {
                        name: 'Status',
                        column: 'supplier_status.name',
                        highlight: 'supplier_status.colour'
                    }
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'View', link: 'view', icon: 'eye',  type: 'router-link', tooltip: 'View', permissions: 'submissions.show' },
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'submissions.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'submissions.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            // Member Search Filter
            const supplierSearchFilter = {
                label: 'Supplier Search',
                name: 'supplier',
                type: 'text',
                width: 'w-1/4',
                value: this.supplierSearchValue,
                placeholder: 'Search Suppliers...'
            };

            this.filters.push(supplierSearchFilter);

            // Member Search Filter
            const memberSearchFilter = {
                label: 'Member Search',
                name: 'member',
                type: 'text',
                width: 'w-1/4',
                value: this.memberSearchValue,
                placeholder: 'Search Members...'
            };

            this.filters.push(memberSearchFilter);

            // Application Statuses
            const applicationFormFilter = {
                label: 'Application Form',
                name: 'application_form',
                type: 'select',
                options: this.$store.getters.forms.map(function (status) {
                    return {label: status.name, value: status.id};
                }),
                width: 'w-1/4',
                value: this.applicationFormValue,
                placeholder: 'Select Application Status...'
            };

            if (this.$store.getters.forms.length === 0){
                this.$store.dispatch('GET_APPLICATION_FORMS').then(() => {
                    applicationFormFilter.options = this.$store.getters.forms.map(function (status) {
                        return { label: status.name, value: status.id };
                    });
                    applicationFormFilter.value = this.applicationFormValue;
                    this.filters.push(applicationFormFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(applicationFormFilter);
            }

            // Supplier Statuses
            const supplierStatusFilter = {
                label: 'Supplier Status',
                name: 'supplier_status',
                type: 'select',
                options: this.$store.getters.supplierStatuses.map(function (status) {
                    return {label: status.name, value: status.id};
                }),
                width: 'w-1/4',
                value: this.supplierStatusValue,
                placeholder: 'Select Supplier Status...'
            };

            if (this.$store.getters.supplierStatuses.length === 0){
                this.$store.dispatch('GET_SUPPLIER_STATUSES').then(() => {
                    supplierStatusFilter.options = this.$store.getters.supplierStatuses.map(function (status) {
                        return { label: status.name, value: status.id };
                    });
                    supplierStatusFilter.value = this.supplierStatusValue;
                    this.filters.push(supplierStatusFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(supplierStatusFilter);
            }
        },
        computed: {
            applicationFormValue(){
                const filters = this.$store.getters.filters;
                if (filters.supplierSubmissions.applicationForm){
                    return filters.supplierSubmissions.applicationForm;
                } else {
                    return null;
                }
            },
            supplierStatusValue(){
                const filters = this.$store.getters.filters;
                if (filters.supplierSubmissions.supplierStatus){
                    return filters.supplierSubmissions.supplierStatus;
                } else {
                    return null;
                }
            },
            memberSearchValue () {
                const filters = this.$store.getters.filters;

                if (filters.supplierSubmissions.member){
                    return filters.supplierSubmissions.member.value;
                } else {
                    return '';
                }
            },
            supplierSearchValue () {
                const filters = this.$store.getters.filters;

                if (filters.supplierSubmissions.supplier){
                    return filters.supplierSubmissions.supplier.value;
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped>

</style>
